import apolloClient from '../../apolloClient';
import translationsQueries from '../queries/translations';

const getTranslations = async (variables) =>
  apolloClient.query({
    query: translationsQueries.GET_TRANSLATIONS,
    variables,
    fetchPolicy: 'no-cache',
  });

export default {
  getTranslations,
};
